import React from "react";
import ItineraryAppointment from "./ItineraryAppointment";
import LinkAppointment from "./LinkAppointment";
import { canLinkAppointment, getId, ItinerarySidebarItem, LinkedItineraryItems } from "./utils";
import { AppointmentSidePanelPlanner } from "components/SidePanel/Appointment/AppointmentSidePanel";
import { itinerarySidebarQueryKey } from "./base";
import { useQueryClient } from "@tanstack/react-query";

interface Props {
  onHoverOver: (appointment: server.dto.PlannerAppointment) => void
  hoveringOver: server.dto.PlannerAppointment
  appointment: server.dto.PlannerAppointment
  item: ItinerarySidebarItem
  canCreateNewAppointment: boolean
  linkedItems: LinkedItineraryItems

  toggleLinked: (appointment: server.dto.PlannerAppointment) => void

  canLinkUnlinkTravel: boolean
  canLinkUnlinkShow: boolean
}

const ItineraryAppointmentRow = (props: Props) => {
  const isHighlighted = (appointment: server.dto.PlannerAppointment) => {
    if (!props.hoveringOver || !appointment) {
      return false;
    }

    return getId(appointment) === getId(props.hoveringOver);
  };

  const isActive = (appointment: server.dto.PlannerAppointment) => {
    if (!appointment || !props.item.itemId) {
      return false;
    }

    if (props.item.type === "show" && appointment.showId === props.item.itemId) {
      return true;
    }

    if (props.item.type === "flight" && appointment.flightSegmentId === props.item.itemId) {
      return true;
    }

    if (props.item.type === "groundTransport" && appointment.groundTransportId === props.item.itemId) {
      return true;
    }

    if (props.item.type === "train" && appointment.trainSegmentId === props.item.itemId) {
      return true;
    }

    return false;
  };

  const queryClient = useQueryClient();

  const onChange = () => {
    queryClient.invalidateQueries([itinerarySidebarQueryKey]);
  }

  return <>
    <td
      onMouseEnter={() => { props.onHoverOver(props.appointment); }}
      onMouseLeave={() => { props.onHoverOver(null); }}
      style={{ cursor: "pointer" }}
    >
      <AppointmentSidePanelPlanner
        appointment={props.appointment}
        onChange={onChange}
      >
        <ItineraryAppointment
          highlighted={isHighlighted(props.appointment)}
          active={isActive(props.appointment)}
          appointment={props.appointment}
        />
      </AppointmentSidePanelPlanner>
    </td>
    {props.canCreateNewAppointment && <>
      {!canLinkAppointment(props.canLinkUnlinkTravel, props.canLinkUnlinkShow, props.item, props.appointment) &&
        <td style={{ width: 30 }}></td>
      }
      {canLinkAppointment(props.canLinkUnlinkTravel, props.canLinkUnlinkShow, props.item, props.appointment) && <LinkAppointment
        appointment={props.appointment}
        linkedItems={props.linkedItems}
        onToggleLinked={() => { props.toggleLinked(props.appointment); }}
      />}
    </>}
  </>;
};

export default ItineraryAppointmentRow;
